angular.module('octopusApp.infrastructure')
    .directive('heightMagic', function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            var windowHeight = $(window).innerHeight()  - 210;
            element.css('min-height', windowHeight);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/height_magic.js
// module id = 661
// module chunks = 1